/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-input-validation[_ngcontent-%COMP%]{position:absolute;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:0 9px 0 15px;width:100%;height:100%;top:0;background:#fff;border-radius:.25rem;border:1px solid #eb0929;pointer-events:none;z-index:2}.disabled[_ngcontent-%COMP%]{background:#edf1f4}.error[_ngcontent-%COMP%]{color:#eb0929;font-size:14px}i[_ngcontent-%COMP%]{padding-left:15px;font-size:15px}.icon-close[_ngcontent-%COMP%]{color:#eb0929}"];
export { styles as styles };
